import React from 'react'
import { useParams, Redirect } from 'react-router-dom'
import { fetchAnswer } from '../../../utils/answerService'
import useQuery, { isLoading } from '../../../hooks/useQuery'
import { isError } from 'react-query'
import TrackingInfoAnswer from '../../organisms/citizens/TrackingInfoAnswer'
import TrackingProcedure from '../../organisms/citizens/TrackingProcedure'
import useCitizenAnswer from '../../../hooks/useCitizenAnswer'

const TrackingInfo = () => {
  const { answerHashId } = useParams()
  const { data: answer, status } = useQuery(['answer', answerHashId], fetchAnswer)
  const { isProcedure } = useCitizenAnswer()
  if (isLoading(status)) return null
  if (isError(status)) return <Redirect to="/seguimiento" />

  return isProcedure(answer) ? <TrackingProcedure code={answerHashId} /> : <TrackingInfoAnswer answer={answer} />
}
export default TrackingInfo
